<ng-container *ngIf="status$ | async | ready as status">
  <app-feature-tile
    feature
    data-at-cs-wifi-lqi
    *ngIf="wifiLqi$ | async | ready as feature"
    [error]="
      (feature | error) ||
      (feature.properties?.strength && feature.properties?.strength?.value < lowLqiSignalThreshold)
    "
    [label]="'+INSTALLATIONS.SRC.ETRV.WIFI_LQI_STRENGTH.TITLE' | translate"
    value="{{
      installationService.isSrcDeviceNotConnected(status)
        ? noValue
        : (feature | value2: featurePropertyKey.strength) + ' ' + (feature | unit: 'strength')
    }}"
    [attr.data-feature]="feature.feature"
    [class.wifi-warning]="
      feature.properties?.strength && feature?.properties?.strength?.value < lowLqiSignalThreshold
    "
    [iconVariant]="iconVariant.error"
  >
  </app-feature-tile>
</ng-container>
